// extracted by mini-css-extract-plugin
module.exports = {"txt-subheader":"DevlinkCheckedList_txt-subheader__9fULp","small":"DevlinkCheckedList_small__7YHo1","ht-checked-list":"DevlinkCheckedList_ht-checked-list__GyMb5"};